import { createRef, useEffect, useState } from "react";

export const useScrollMotion = ({ delay }: { delay?: number }) => {
 const ref = createRef<HTMLDivElement>();
 const [display, setDisplay] = useState<boolean>(false);
 useEffect(() => {
  const onScroll = () => {
   if (ref.current) {
    if (window.scrollY + window.innerHeight / 2 >= ref.current.offsetTop) {
     if (delay)
      setTimeout(() => {
       setDisplay(true);
      }, delay * 1000);
     else setDisplay(true);
    } else {
     setDisplay(false);
    }
   }
  };
  document.addEventListener("scroll", onScroll);
  return () => document.removeEventListener("scroll", onScroll);
 }, []);
 return { ref, display };
};

export const useScroll = () => {
 const [scrollY, setScrollY] = useState<number>(0);
 useEffect(() => {
  const onScroll = () => {
   setScrollY(window.scrollY);
  };
  document.addEventListener("scroll", onScroll);
  return () => document.removeEventListener("scroll", onScroll);
 }, []);
 return { scrollY };
};
